import {PaytableModule} from 'src/paytable/PaytableModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {FreeGamesBetData} from '@fantasmagames/slot/src/logic/integration/FreeGamesData';

export class RecodePaytableModule extends PaytableModule {
	protected setupEvents(): void {
		super.setupEvents();
	}

	protected showPaytable(): void {
		if ((this.logic as RecodeLogic).hasFreeGames()) {
			this.updatePaytableFreeGames();
		}
		super.showPaytable();
	}

	protected updatePaytableFreeGames(): void {
		const betData: FreeGamesBetData = (this.logic as RecodeLogic).getCurrentFreeGamesData().betData;
		const multiplier = betData.chipSize * betData.numChips * RecodeLogic.CENT_TO_A_DOLLAR;

		this.updatePaytableValues(multiplier);
	}
}



// WEBPACK FOOTER //
// ./src/paytable/recode/RecodePaytableModule.ts